import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import useOneTrustAnalyticsConsentAllowed from '@/hooks/consent/useOneTrustAnalyticsConsentAllowed';
import {amplitude} from '@/services/analytics/amplitude';
import {selectIsLoggedIn} from '@/state/selectors/auth';
import {
    selectIsAggregatedSettingsFetched,
    selectIsAmplitudeEnabled,
} from '@/state/selectors/consumerAggregatedSettings';

const useAmplitudeOptOut = () => {
    const isLoggedIn = useSelector(selectIsLoggedIn);
    const isAggregatedSettingsFetched = useSelector(selectIsAggregatedSettingsFetched);
    const isAmplitudeEnabled = useSelector(selectIsAmplitudeEnabled);
    const isOneTrustAnalyticsAllowed = useOneTrustAnalyticsConsentAllowed();

    useEffect(() => {
        // if logged in -> check aggregatedSettings
        if (isLoggedIn) return;

        // disable amplitude after logout
        amplitude.enableAmplitude(false);
    }, [isLoggedIn]);

    useEffect(() => {
        if (!isAggregatedSettingsFetched) return;

        const shouldEnableAmplitude = isAmplitudeEnabled && isOneTrustAnalyticsAllowed;

        amplitude.enableAmplitude(shouldEnableAmplitude);
    }, [isAggregatedSettingsFetched, isAmplitudeEnabled, isOneTrustAnalyticsAllowed]);
};

export default useAmplitudeOptOut;
